import React, { useState } from 'react';
import ReactDOM from 'react-dom';

interface ReviewModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: (rating: number, content: string) => void;
}

export const ReviewModal: React.FC<ReviewModalProps> = ({
                                                            isOpen, onClose, onConfirm,
                                                        }) => {
    const [rating, setRating] = useState<number>(0);
    const [content, setContent] = useState<string>('');
    const modalRoot = document.getElementById('modal-root');

    React.useEffect(() => {
        if (isOpen) {
            document.body.classList.add('modal-open');
            setRating(0);
            setContent('');
        }
        return () => document.body.classList.remove('modal-open');
    }, [isOpen]);

    if (!isOpen || !modalRoot) return null;

    const byteLength = new TextEncoder().encode(content).length;

    return ReactDOM.createPortal(
        <div className="modal" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} onClick={onClose}>
            <div className="modal-dialog" onClick={(e) => e.stopPropagation()}>
                <div className="modal-content" style={{ backgroundColor: 'white' }}>
                    <div className="modal-header line-header">
                        <h3>코디 후기</h3>
                    </div>

                    <div className="modal-body">
                        <div className="modal-info-p">
                            <strong className="block">서비스가 정상적으로 종료되었습니다.</strong>
                            <span className="block">매칭된 코디의 후기를 작성해 주세요.</span>
                        </div>

                        <form className="form-box">
                            <fieldset>
                                <legend>코디 후기 작성</legend>
                                <div className="form-item">
                                    <div className="star-check-row">
                                        {[1, 2, 3, 4, 5].map((star) => (
                                            <span className="star-check" key={star}>
                        <input
                            type="checkbox"
                            id={`rating${star}`}
                            name="rating"
                            className="blind"
                            checked={star <= rating}
                            onChange={() => setRating(star)}
                        />
                        <label htmlFor={`rating${star}`}></label>
                      </span>
                                        ))}
                                    </div>
                                </div>
                                <div className="form-item">
                                    <div className="input-box">
                    <textarea
                        className="com"
                        placeholder="코디 후기를 작성해 주세요."
                        value={content}
                        maxLength={300}
                        onChange={(e) => {
                            const newValue = e.target.value;
                            if (new TextEncoder().encode(newValue).length <= 300) {
                                setContent(newValue);
                            }
                        }}
                    />
                                        <span className="unit">
                      <strong className="point">{byteLength}</strong>/300 byte
                    </span>
                                    </div>
                                </div>
                            </fieldset>
                        </form>
                    </div>

                    <div className="modal-footer">
                        <div className="modal_btn">
                            <button type="button" className="btn cancel" onClick={onClose}>닫기</button>
                            <button
                                type="button"
                                className="btn confirm"
                                onClick={() => {
                                    if (!content.trim()) {
                                        alert('후기를 작성해주세요.');
                                        return;
                                    }
                                    if (new TextEncoder().encode(content).length > 300) {
                                        alert('후기는 300byte 이내로 작성해주세요.');
                                        return;
                                    }
                                    onConfirm(rating, content);
                                }}
                            >
                                서비스 종료
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>,
        modalRoot
    );
};